import {useMutation} from '@apollo/client';
import {Close} from '@mui/icons-material';
import {
  Button,
  Grid,
  IconButton,
  Modal,
  Slide,
  Typography,
} from '@mui/material';
import {useEffect, useState} from 'react';
import Input from '../../../components/input/input';
import {toastNotification} from '../../../components/toastify';
import {CREATE_ESPECIALIDADE_MEDICA} from '../../../graphql/mutation';

export default function EspecialidadeModal({especialidade = {}, open, onClose}) {
  const [formData, setFormData] = useState(especialidade);

  useEffect(() => {
    setFormData(especialidade);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const [saveEspecialidade] = useMutation(CREATE_ESPECIALIDADE_MEDICA);

  const onSaveEspecialidade = () => {
    if (!formData.descricao) return;

    saveEspecialidade({
      variables: {
        especialidade: {
          id: especialidade.id,
          descricao: formData.descricao,
        },
      },
    })
      .then(onClose)
      .catch((error) =>
        toastNotification({message: error.message, type: 'error'}),
      );
  };

  useEffect(() => {
    if (open) return;

    setFormData({});
  }, [open]);

  return (
    <Modal open={open} onClose={onClose} sx={styles.modal}>
      <Slide in={open} appear>
        <Grid
          container
          className="styled-scroll-transparent-desktop"
          sx={styles.container}>
          <Grid container item sx={styles.header}>
            <Typography sx={styles.title}>ESPECIALIDADE MÉDICA</Typography>
            <IconButton sx={styles.closeIcon} onClick={onClose}>
              <Close />
            </IconButton>
          </Grid>
          <Grid container sx={styles.content}>
            <Grid container item spacing={2}>
              <Grid item xs={12}>
                <Input
                  label="Descricao"
                  placeholder={'Descriçao'}
                  name="descricao"
                  type="text"
                  value={formData.descricao || ''}
                  onChange={({target}) =>
                    setFormData((f) => ({...f, descricao: target?.value}))
                  }
                />
              </Grid>
            </Grid>
            <Grid item xs={12} paddingTop={4}>
              <Button id="primary" onClick={onSaveEspecialidade}>
                Salvar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Slide>
    </Modal>
  );
}

const styles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    position: 'relative',
    maxHeight: '90vh',
    width: '50%',
    borderRadius: '6px',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    padding: 3,
    paddingTop: 0,
    zIndex: (theme) => theme.zIndex.modal,
    background: (theme) => theme.palette.blackSecundary,
    boxShadow: '0px 0px 134.60001px 0px rgba(255, 204, 41, 0.25)',
    outline: 'none',
    overflowY: 'auto',

    '@media (max-width: 900px)': {
      width: '90%',
    },
  },
  header: {
    flexGrow: 0,
    padding: 2,
    justifyContent: 'space-between',
    svg: {
      color: '#fff',
    },
  },
  closeIcon: {
    width: '32px',
    height: '32px',
  },
  title: {
    color: '#FFF',
    textAlign: 'center',
    fontFamily: 'Now',
    fontSize: '24px',
    fontWeight: '700',
    textTransform: 'uppercase',

    '@media (max-width: 1200px)': {
      fontSize: '20px',
    },
  },
  content: {
    flexDirection: 'row',
    width: '100%',
    padding: '16px',
  },
};
